var map = {
	"./je-f-21.03.01.xlsx": "df04",
	"./logo-fri_reg.svg": "afa1",
	"./logo-fri_reg_old.svg": "da0c",
	"./logo_DE.png": "71b3",
	"./logo_FR.png": "9dd1",
	"./nav.png": "be6e",
	"./nav_old.png": "bbf1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35ee";